// import {getUserData} from "../modulesUtils";
import {truncate,scaleBetween} from "../../utils/common";

let mtModule = null;

// function userNotPremium(anonymous)
// {
//     const notPremium = '<a href="/suscripcion" class=\"lnk\" title=\"Para ver este contenido debes suscribirte\">Suscríbete</a> ';
//     const notRegister = notPremium + '&nbsp; o &nbsp; <a href="#suscriptionModal" class="lnk" title="Para ver este contenido debes ser suscriptor" data-lightbox="">accede</a>';
//     mtModule.innerHTML = anonymous ? notRegister : notPremium
// }

const colors = ['mtM6', 'mtM4', 'mtM2', 'mt0', 'mt2', 'mt4', 'mt6']

const getPremiumModuleSquares = (data) => {
    const div = document.createElement('div');
    div.title = data.text;
    div.classList.add('tradingSquare__holder');
    const active = 'active animation';

    for(let i = 0; i <= 6; i++) {
        const style = `tradingSquare ${colors[i]} ${data.squares === (i+1) ? active : ''}`
        div.insertAdjacentHTML("beforeend",`<div class="${style}"></div>`);
    }

    return div;
}

const loadTradingMonitorData = async (idTicker) => {
    const url = `${unmaskpath(JSVAR.base_url)}/cotizaciones-mt/${idTicker}`
    const result = await fetch(url);
    if (!result.ok) {
        throw new Error('User menu request has returned non 200 code');
    }
    return result.json();
}

const drawMt = async (idTicker) => {
    try{
        const data = await loadTradingMonitorData(idTicker);

        if (!data || !data.text) {
            throw new Error('Invalid value');
        }
        const text = truncate(data.text, 8);
        mtModule.innerHTML = '';
        mtModule.appendChild(getPremiumModuleSquares(data));
        mtModule.insertAdjacentHTML('beforeend', '<div class="premiumData__text">'+text+'</div>')
    } catch(err) {
        console.error(err)
        mtModule.innerHTML = "No disponible"
    }
}

/**
 * Carga el valor para la máquina de trading en el módulo premium superior de fichas de cotización
 */
export const premiumMT = async () => {
    mtModule = document.querySelector('.premiumData__container.premiumData__mtContainer');
    if (!mtModule) {
        return;
    }

    const idTicker = mtModule.dataset.instrument;
    await drawMt(idTicker)

    //
    // try {
    //     const userData = await getUserData();
    //     const isPremium = userData && userData.hasOwnProperty('premium') && userData.premium === true;
    //     const isTrial = userData && userData.hasOwnProperty('trial') && userData.trail === true;
    //
    //     if (isPremium || isTrial) {
    //         const idTicker = mtModule.dataset.instrument;
    //         await drawMt(idTicker)
        //     //premium.
        // } else if (userData && userData.login) {
        //     return userNotPremium(false);
        // } else {
        //     return userNotPremium(true);
        // }

    // } catch (e) {
    //     return userNotPremium(true);
    // }
}
